// extracted by mini-css-extract-plugin
export default {"logoHomepage":"Homepage_logoHomepage__KdB84","mainHomepage":"Homepage_mainHomepage__412nD"};